import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-108">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 p-3 bg-white/95 backdrop-blur-md border-t border-warm-beige shadow-[0_-4px_20px_rgba(0,0,0,0.08)] md:hidden z-40" data-id="element-109">
          <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="btn-pulse w-full bg-copper text-white py-3.5 rounded-full font-bold shadow-lg text-sm text-center flex items-center justify-center gap-2" data-id="element-110">
            Quiero Mi Ebook Ahora
            <ArrowRight size={16} data-id="element-111" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}